import type { Mission } from '../missions.ts'

export const dsca: Mission = {
  id: "dsca",
  name: "Defense Security Cooperation Agency",
  short: "DSCA",
  call: "Security Cooperation",
  kind: "subagency",
  parent: "dod",
  url: "https://www.dsca.mil/",
  established: 1971,
  palette: {
    primary: "#192963",
    secondary: "#5f8c3d",
    accent: "#d0af2b",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:Seal_of_the_Defense_Security_Cooperation_Agency.jpg",
  },
  motif: "shield",
  mission: {
    text: "The Defense Security Cooperation Agency’s mission is to advance U.S. national security and foreign policy interests by building the capacity of foreign security forces to respond to shared challenges.",
    url: "https://www.dsca.mil/About-DSCA/Mission-and-Vision",
  },
  fact: {
    text: "DSCA began in 1971 as the Defense Security Assistance Agency, created with 90 employees to make security cooperation a formal function of the Defense Department.",
    url: "https://www.dsca.mil/Press-Media/Article-Display/Article/3991053/dod-recognizes-50-years-of-security-cooperation",
  },
  seal: {
    file: "public/seals/dsca.png",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_Defense_Security_Cooperation_Agency.jpg",
  },
  identifier: {
    about: "https://www.dsca.mil/About-DSCA",
    accessibility: "https://dowcio.war.gov/508/",
    foia: "https://www.dsca.mil/FOIA",
    noFear: "https://www.dsca.mil/No-Fear-Act",
    oig: "https://www.dodig.mil/",
    performance: "https://dam.defense.gov/Performance-Mgmt/",
    privacy: "https://www.dsca.mil/Privacy-and-Security",
  },
  media: {
    photos: [
      {
        file: "/media/dsca-c130-colombia.jpg",
        small: "/media/dsca-c130-colombia-sm.jpg",
        alt: "A gray C-130E Hercules seen from behind on a desert flight line at dusk, its tail rising against a hazy orange sky.",
        title: "C-130E Hercules awaiting delivery to Colombia through the Excess Defense Articles program, Davis-Monthan Air Force Base, Arizona, September 14, 2020",
        creator: "Tech. Sgt. Angela Ruiz, U.S. Air Force",
        source: "https://commons.wikimedia.org/wiki/File:200914-F-EY492-134.jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/dsca-humanitarian-depot.jpg",
        small: "/media/dsca-humanitarian-depot-sm.jpg",
        alt: "Tall warehouse racks stacked with wrapped pallets of furniture and supplies, with a forklift working in the aisle between them.",
        title: "Humanitarian Assistance Program shipment for Armenia being prepared at Camp Darby, Livorno, Italy, 2023",
        creator: "Elena Baladelli, U.S. Army",
        source: "https://commons.wikimedia.org/wiki/File:Humanitarian_Assistance_Program,_Italy_-_shipment_to_Armenia_(8115772).jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
